<template>
  <CDropdown
    :toggler-text="orderOption"
    placement="right-start"
    addTogglerClasses="customDropDownColor"
  >
    <CDropdownItem @click="orderOption = 'A-Z'">A-Z</CDropdownItem>
    <CDropdownItem @click="orderOption = 'Z-A'">Z-A</CDropdownItem>
  </CDropdown>
</template>

<script>
export default {
  name: "alphabeticalOrder",
  data() {
    return {
      orderOption: "A-Z"
    };
  }
};
</script>
